export default __webpack_public_path__ + "2ff3a97eeaa96f238b627b01128ba0c4.png";